import { PathOptions } from 'leaflet'

export type FieldState = 'disabled' | 'enabled' | 'selected'

export const FIELD_STATE_STYLES = {
  disabled: {
    color: '#FFFFFF',
    fillColor: 'transparent',
    opacity: 0.5,
    fillOpacity: 0.25,
    weight: 2,
  },
  enabled: {
    color: '#FFFFFF',
    fillColor: '#FFFFFF',
    opacity: 1,
    fillOpacity: 0.25,
    weight: 2,
  },
  selected: {
    color: '#0059DE',
    fillColor: '#0059DE',
    opacity: 1,
    fillOpacity: 0.25,
    weight: 2,
  },
  hover: {
    color: '#64b5f6',
    fillColor: '#64b5f6',
    opacity: 1,
    fillOpacity: 0.25,
    weight: 2,
  },
}

export const getFieldStyles = (
  isEnabled: boolean,
  isSelected: boolean,
): PathOptions => {
  const state = getFieldState(isEnabled, isSelected)
  return FIELD_STATE_STYLES[state] as PathOptions
}

export const Field_HOVER_STYLE: PathOptions = {
  color: FIELD_STATE_STYLES.hover.color,
  weight: FIELD_STATE_STYLES.hover.weight,
}

const getFieldState = (isEnabled: boolean, isSelected: boolean): FieldState => {
  if (!isEnabled) return 'disabled'
  if (isSelected) return 'selected'
  return 'enabled'
}
